<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

function syncThumbnailHeight() {
  const thumbs = document.querySelector('.productView-thumbnail-wrapper');
  const mainImage = document.querySelector('.productView-image-wrapper');

  if (!thumbs || !mainImage) return;

  // Only apply on desktop
  if (window.innerWidth < 1280) {
    thumbs.style.removeProperty('--main-gallery-height');
    thumbs.style.height = '';

    const slickList = thumbs.querySelector('.slick-list');
    if (slickList) slickList.style.height = '';

    return;
  }

  const height = mainImage.offsetHeight;

  thumbs.style.setProperty('--main-gallery-height', `${height}px`);

  const slickList = thumbs.querySelector('.slick-list');
  if (slickList) {
    slickList.style.height = `${height - 70}px`;
  }
}

window.addEventListener('load', syncThumbnailHeight);
window.addEventListener('resize', syncThumbnailHeight);
document.addEventListener('shopify:section:load', syncThumbnailHeight);

// ============================================================================= //
// Homepage hero video banner (slide_show_kaU8KZ / video_ipWhUd): insert the review
// badges (Judge.me / Google) immediately after the "Shop Best Sellers" button.
// This is done via JS DOM insertion rather than the block's sub_heading field or
// the reviews_judgeme/reviews_google settings, because: (1) sub_heading rendered
// BEFORE the heading/button (sub_title_position was "sub_title_above"), so no
// CSS could reliably move it below the button without a flex container; and
// (2) reviews_judgeme/reviews_google are only declared in the section schema for
// the "image" block type, not "video" - Shopify silently strips those settings
// on save for a video block, so they can't be relied on here. This guarantees
// correct placement regardless. Sizing is handled separately in custom.css,
// scoped to .slide-block-video_ipWhUd .grouped_reviews_item.
// ============================================================================= //
function insertVideoSlideReviewBadges() {
  var wrapper = document.querySelector('.slide-block-video_ipWhUd .slide-content');
  if (!wrapper) return;
  if (wrapper.querySelector('.grouped_reviews_slide')) return;
  var buttons = wrapper.querySelectorAll('.slide-button');
  if (!buttons.length) return;
  var lastButton = buttons[buttons.length - 1];
  var anchor = lastButton.closest('.scroll-trigger') || lastButton;
  var badges = document.createElement('div');
  badges.className = 'grouped_reviews_slide';
  badges.innerHTML = '<div class="grouped_reviews_item"><p>★★★★★ 4.8 on Judge.me</p></div><div class="grouped_reviews_item"><p>★★★★★ 4.7 on Google Reviews</p></div>';
  anchor.insertAdjacentElement('afterend', badges);
}

window.addEventListener('DOMContentLoaded', insertVideoSlideReviewBadges);
window.addEventListener('load', insertVideoSlideReviewBadges);
document.addEventListener('shopify:section:load', insertVideoSlideReviewBadges);

// ============================================================================= //
// Lip Combo swatch circles on PDP: each circle represents a DIFFERENT product //
// (not a variant of the current one), but the swatch app only swaps the        //
// preview image - it never navigates. This links each circle to its real PDP.  //
// ============================================================================= //
(function () {
  var COMBO_PRODUCT_URLS = {
    bombshell: '/products/ultimate-lip-combo-miss-bombshell',
    malibu: '/products/ultimate-look-lip-kit-miss-malibu',
    empower: '/products/the-ultimate-look-lip-kit-miss-empowered',
    vivacious: '/products/ultimate-look-lip-kit-3-miss-vivacious',
    unapologetic: '/products/ultimate-look-lip-kit-2-miss-unapologetic',
    luscious: '/products/ultimate-look-lip-kit-miss-luscious',
    sassy: '/products/ultimate-look-lip-kit-miss-sassy',
    chic: '/products/ultimate-look-lip-kit-miss-chic'
  };

  function comboUrlFromLabel(label) {
    if (!label) return null;
    var lower = label.toLowerCase();
    for (var key in COMBO_PRODUCT_URLS) {
      if (lower.indexOf(key) !== -1) return COMBO_PRODUCT_URLS[key];
    }
    return null;
  }

  function currentProductHandle() {
    var match = location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function linkComboSwatches() {
    var items = document.querySelectorAll('.po-imageOption-swatchWrapperItem');
    if (!items.length) return;

    items.forEach(function (item) {
      if (item.dataset.comboLinked === 'true') return;
      item.dataset.comboLinked = 'true';

      var img = item.querySelector('img');
      var label = img ? img.getAttribute('alt') : '';
      var url = comboUrlFromLabel(label);
      if (!url) return;

      var currentHandle = currentProductHandle();
      if (currentHandle && url.indexOf(currentHandle) !== -1) {
        // Already viewing this combo's product page - leave default behavior.
        return;
      }

      item.style.cursor = 'pointer';
      item.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = url;
      }, true);
    });
  }

  function initComboSwatchLinks() {
    linkComboSwatches();
    var observer = new MutationObserver(linkComboSwatches);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComboSwatchLinks);
  } else {
    initComboSwatchLinks();
  }
  document.addEventListener('shopify:section:load', linkComboSwatches);
})();

// ============================================================================= //
// Hide the Easify "Lip Combos" option-swatch set on PDPs. We now have a native  //
// Lip Combos collection-links block (right under the price) that covers the     //
// same job, so the Easify widget further down the sidebar is a visual duplicate //
// - keep it functional in Easify's own admin, just don't show it on the page.   //
// ============================================================================= //
(function () {
  function hideEasifyLipCombosOption() {
    var sets = document.querySelectorAll('.po-optionSet-root');
    sets.forEach(function (set) {
      if (set.dataset.lipCombosHidden === 'true') return;
      var label = set.querySelector('[class*="po-label"]');
      if (label && /lip combos/i.test((label.textContent || '').trim())) {
        set.dataset.lipCombosHidden = 'true';
        set.style.display = 'none';
      }
    });
  }

  function init() {
    hideEasifyLipCombosOption();
    var observer = new MutationObserver(hideEasifyLipCombosOption);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', hideEasifyLipCombosOption);
})();

// ============================================================================= //
// Blog article redesign: reading time + auto-generated table of contents.       //
// Runs on any page with the .article-content.halo-text-format rte body.        //
// ============================================================================= //
(function () {
  function slugify(text) {
    return (text || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '') || 'section';
  }

  function buildReadingTimeAndToc() {
    var body = document.querySelector('.article-content.halo-text-format');
    if (!body || body.dataset.tocBuilt === 'true') return;
    body.dataset.tocBuilt = 'true';

    var wordCount = (body.textContent || '').trim().split(/\s+/).filter(Boolean).length;
    var minutes = Math.max(1, Math.round(wordCount / 200));
    var infoRow = document.querySelector('.article-heading .info');
    if (infoRow && !infoRow.querySelector('.info-item.reading-time')) {
      var span = document.createElement('span');
      span.className = 'info-item reading-time';
      span.textContent = minutes + ' min read';
      infoRow.appendChild(span);
    }

    var headings = Array.from(body.querySelectorAll('h2'));
    if (headings.length < 3) return;

    var usedIds = {};
    var listItems = headings.map(function (h) {
      var base = slugify(h.textContent);
      var id = base;
      var i = 1;
      while (usedIds[id]) { id = base + '-' + (++i); }
      usedIds[id] = true;
      h.id = id;
      return '<li><a href="#' + id + '">' + h.textContent + '</a></li>';
    }).join('');

    var toc = document.createElement('div');
    toc.className = 'blog-toc';
    toc.innerHTML = '<p class="blog-toc__title">In this article</p><ul class="blog-toc__list">' + listItems + '</ul>';
    body.parentNode.insertBefore(toc, body);
  }

  function placeAfterHeading(template, heading) {
    if (!heading || !template) return;
    template.style.display = '';
    template.removeAttribute('data-shop-post-callout-template');
    heading.parentNode.insertBefore(template, heading.nextSibling);
  }

  function insertMidArticleCallouts() {
    var templates = document.querySelectorAll('[data-shop-post-callout-template]');
    var body = document.querySelector('.article-content.halo-text-format');
    if (!templates.length || !body || body.dataset.calloutsInserted === 'true') return;
    body.dataset.calloutsInserted = 'true';

    var headings = Array.from(body.querySelectorAll('h2'));
    if (headings.length < 2) return;

    if (headings.length < 4) {
      var mid = headings[Math.floor(headings.length / 2)];
      placeAfterHeading(templates[0], mid);
      return;
    }

    var firstIndex = Math.max(1, Math.floor(headings.length * 0.35) - 1);
    var secondIndex = Math.min(headings.length - 1, Math.floor(headings.length * 0.7));

    placeAfterHeading(templates[0], headings[firstIndex]);
    if (secondIndex !== firstIndex) {
      placeAfterHeading(templates[1], headings[secondIndex]);
    }
  }

  function initBlogRedesign() {
    buildReadingTimeAndToc();
    insertMidArticleCallouts();
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.blog-toc__list a');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogRedesign);
  } else {
    initBlogRedesign();
  }
  document.addEventListener('shopify:section:load', initBlogRedesign);
})();
